<template>
  <v-container id="edit-profile" fluid tag="section" class="cyber-page">
    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card
          color="#018C74"
          icon="mdi-account-edit-outline"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">
              EDIT PROFIL & PASSWORD
            </div>
          </template>

          <v-alert
            v-if="isProtectedUser"
            type="warning"
            dense
            outlined
            class="mt-4 mb-0 mx-2"
            color="#CFA22D"
          >
            Akun anda terintegrasi dengan SIMPEG. Ubah password di SIMPEG.
          </v-alert>

          <v-form ref="form" v-model="valid" class="mt-4">
            <v-row dense>
              <v-col cols="12">
                <small class="secondary-text font-weight-bold"
                  >INFORMASI AKUN & ROLE</small
                >
                <v-divider class="mb-4" color="#018C74"></v-divider>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="currentUser.username"
                  label="USERNAME"
                  outlined
                  disabled
                  color="#018C74"
                  prepend-inner-icon="mdi-identifier"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.nama"
                  :rules="[(v) => !!v || 'Nama wajib diisi']"
                  label="NAMA LENGKAP"
                  :disabled="isProtectedUser"
                  outlined
                  color="#018C74"
                  prepend-inner-icon="mdi-account-box-outline"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="userRole.role_name"
                  label="HAK AKSES"
                  outlined
                  disabled
                  color="#CFA22D"
                  prepend-inner-icon="mdi-shield-account"
                />
              </v-col>

              <v-col cols="12" class="mt-4">
                <small class="secondary-text font-weight-bold">KEAMANAN</small>
                <v-divider class="mb-4" color="#CFA22D"></v-divider>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.newPassword"
                  :rules="[(v) => !v || v.length >= 6 || 'Minimal 6 karakter']"
                  label="PASSWORD BARU"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show1 = !show1"
                  outlined
                  color="#CFA22D"
                  prepend-inner-icon="mdi-lock-outline"
                  :disabled="isProtectedUser"
                  persistent-hint
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.confirmPassword"
                  :rules="[(v) => v === form.newPassword || 'Password tidak cocok!']"
                  label="KONFIRMASI PASSWORD"
                  :type="show2 ? 'text' : 'password'"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show2 = !show2"
                  outlined
                  color="#CFA22D"
                  prepend-inner-icon="mdi-lock-check-outline"
                  :disabled="isProtectedUser"
                />
              </v-col>
            </v-row>

            <v-card-actions class="px-0 pt-6">
              <v-btn text color="#6b7b78" @click="resetToInitial">RESET</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!valid || isProtectedUser"
                :loading="loading"
                color="#CFA22D"
                class="black--text font-weight-bold"
                @click="updateProfile"
              >
                <v-icon left>mdi-content-save-check-outline</v-icon>
                SIMPAN PERUBAHAN
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" top>
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
const API_URL = "https://berkah.bondowosokab.go.id:5500/master/user";

export default {
  data: () => ({
    valid: false,
    loading: false,
    show1: false,
    show2: false,
    currentUser: { username: "" },
    userRole: { role_id: null, role_name: "" },
    form: {
      nama: "",
      newPassword: "",
      confirmPassword: "",
    },
    snackbar: { show: false, text: "", color: "" },
  }),

  computed: {
    isProtectedUser() {
      const username = this.currentUser.username || "";
      return /^\d{18}$/.test(username);
    },
  },

  mounted() {
    this.loadDataFromStorage();
  },

  methods: {
    loadDataFromStorage() {
      const userData = localStorage.getItem("userData");
      if (userData) {
        this.currentUser = JSON.parse(userData);
        this.form.nama = this.currentUser.nama;
      }

      const roleData = localStorage.getItem("userRole");
      if (roleData) {
        this.userRole = JSON.parse(roleData);
      }
    },

    async updateProfile() {
      if (!this.$refs.form.validate() || this.isProtectedUser) return;

      this.loading = true;
      try {
        const payload = {
          username: this.currentUser.username,
          nama: this.form.nama,
          role_id: Number(this.userRole.role_id),
          is_active: 1,
        };

        if (this.form.newPassword) {
          payload.password = this.form.newPassword;
        }

        const res = await axios.put(`${API_URL}/${this.currentUser.id}`, payload);

        if (res.data.metadata.code === 200) {
          const updatedUserData = { ...this.currentUser, nama: this.form.nama };
          localStorage.setItem("userData", JSON.stringify(updatedUserData));

          this.showSnackbar("Profil & Hak Akses berhasil diperbarui!", "#018C74");
          this.form.newPassword = "";
          this.form.confirmPassword = "";
        } else {
          throw new Error(res.data.metadata.message);
        }
      } catch (e) {
        const errorMsg =
          e.response?.data?.response?.data || "Gagal menyimpan perubahan profil.";
        this.showSnackbar(errorMsg, "#FF5252");
      } finally {
        this.loading = false;
      }
    },

    resetToInitial() {
      this.loadDataFromStorage();
      this.form.newPassword = "";
      this.form.confirmPassword = "";
      this.$refs.form.resetValidation();
    },

    showSnackbar(text, color) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
  },
};
</script>

<style scoped>
.cyber-page {
  background: transparent;
  padding-top: 30px;
}
.cyber-text {
  letter-spacing: 2px !important;
  color: white !important;
  text-shadow: 0 0 10px rgba(1, 140, 116, 0.5);
}
.secondary-text {
  color: #cfa22d !important;
  letter-spacing: 1px;
}
.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
